import config from '@/config/config.json';
import { EnvironmentType } from '@/types/environmentType';
import { NameType } from '@/types/configType';

type ConfigData = Record<string, Array<{ url: string; names: string | NameType[] }>>;

export default function useConfig({ type, defaultUrl }: Omit<EnvironmentType, 'defaultName'>) {
  return async function getConfig() {
    const data = config as ConfigData;
    return data[type]?.flatMap(({ url, names }: { url: string; names: string | NameType[] }) => {
      const fullUrl = url.replace('../', `${defaultUrl}/`);
      const namesArr = Array.isArray(names) ? names : [{ name: names, group: '' }];

      return namesArr.map(nameObj => ({
        url: fullUrl,
        name: nameObj.name,
        group: nameObj.group,
      }));
    });
  };
}
